import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-476804b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sa-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "sa-page-title" }, "Super-Administration", -1))
const _hoisted_3 = { class: "sa-subnav" }
const _hoisted_4 = { class: "sa-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "sa-title" }, "Organisationen"),
  /*#__PURE__*/_createElementVNode("p", { class: "sa-subtitle" }, "Alle Einrichtungen verwalten und neue Organisationen anlegen")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "sa-success"
}
const _hoisted_7 = {
  key: 1,
  class: "sa-switch-error"
}
const _hoisted_8 = {
  key: 2,
  class: "sa-loading"
}
const _hoisted_9 = {
  key: 3,
  class: "sa-error"
}
const _hoisted_10 = {
  key: 4,
  class: "sa-card"
}
const _hoisted_11 = { class: "sa-table" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Plattform"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_13 = { class: "sa-org-name" }
const _hoisted_14 = { class: "sa-id" }
const _hoisted_15 = { class: "sa-actions" }
const _hoisted_16 = ["disabled", "onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "sa-empty"
}, "Noch keine Organisationen vorhanden.", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "sa-modal" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Neue Organisation anlegen", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Es wird eine Organisation samt erstem Admin (OWNER) erstellt. Der Admin erhält eine Einladungs-E-Mail mit Zugangsdaten.", -1))
const _hoisted_23 = { class: "sa-form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name der Organisation *", -1))
const _hoisted_25 = { class: "sa-form-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name des Admins *", -1))
const _hoisted_27 = { class: "sa-form-group" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "E-Mail des Admins *", -1))
const _hoisted_29 = {
  key: 0,
  class: "sa-form-error"
}
const _hoisted_30 = { class: "sa-modal-actions" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/superadmin/organisations",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Organisationen")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/superadmin/courses",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Kurse")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/superadmin/instruction-library",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Unterweisungen")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreate && _ctx.openCreate(...args)))
      }, "+ Neue Organisation")
    ]),
    (_ctx.successMsg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.successMsg), 1))
      : _createCommentVNode("", true),
    (_ctx.switchError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.switchError), 1))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Organisationen werden geladen …"))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.error), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organisations, (org) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: org.organisationId
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(org.name || '—'), 1)
                    ]),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(org.organisationId), 1),
                    _createElementVNode("td", null, _toDisplayString(org.platformId || '—'), 1),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("button", {
                        class: "btn btn-secondary btn-open",
                        disabled: _ctx.switchingId !== null,
                        onClick: ($event: any) => (_ctx.openOrg(org))
                      }, _toDisplayString(_ctx.switchingId === org.organisationId ? 'Wird geöffnet …' : 'Öffnen'), 9, _hoisted_16)
                    ])
                  ]))
                }), 128)),
                (_ctx.organisations.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _hoisted_19))
                  : _createCommentVNode("", true)
              ])
            ])
          ])),
    (_ctx.showCreate)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "sa-modal-backdrop",
          onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeCreate && _ctx.closeCreate(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.orgName) = $event)),
                type: "text",
                class: "sa-input",
                placeholder: "z. B. Pflegeheim Sonnenhof"
              }, null, 512), [
                [_vModelText, _ctx.form.orgName]
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.adminName) = $event)),
                type: "text",
                class: "sa-input",
                placeholder: "Vor- und Nachname"
              }, null, 512), [
                [_vModelText, _ctx.form.adminName]
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.adminEmail) = $event)),
                type: "email",
                class: "sa-input",
                placeholder: "admin@einrichtung.de"
              }, null, 512), [
                [_vModelText, _ctx.form.adminEmail]
              ])
            ]),
            (_ctx.formError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.formError), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                disabled: _ctx.saving,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeCreate && _ctx.closeCreate(...args)))
              }, "Abbrechen", 8, _hoisted_31),
              _createElementVNode("button", {
                class: "btn btn-primary",
                disabled: _ctx.saving,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitCreate && _ctx.submitCreate(...args)))
              }, _toDisplayString(_ctx.saving ? 'Wird angelegt …' : 'Anlegen'), 9, _hoisted_32)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}